import { dateRequiredSchema, endDateSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, number, object } from 'yup';

const taskTemplateSchema = object().shape({
    task_title: stringRequiredSchema,
    description: stringRequiredSchema,
    // tracker_type: object().shape({
    //     label: stringRequiredSchema,
    //     value: stringRequiredSchema, 
    // }).required(stringRequiredSchema),
});

export default taskTemplateSchema;